import React from 'react';
import { FormatComponentProps } from './types';

const PlainText: React.FC<FormatComponentProps> = ({ content }) => {
  // Replace newlines following a digit and period (e.g., "1.\n") with a space
  const processedText = content.replace(/(\d+\.)\n\s*/g, '$1 ');
  return (
    <span
      style={{
        whiteSpace: 'pre-line',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        wordBreak: 'break-word'
      }}
    >
      {processedText}
    </span>
  );
};

export default PlainText;
